import { HttpClient } from '@angular/common/http';
import { Base } from './base';
import { Oracles } from './beta/oracles';

export class Beta extends Base {
  oracles: Oracles;

  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'beta');
    this.oracles = new Oracles(this.httpClient, this.resource);
  }
}
